const INIT_URL = "init_url";
const LOB = "railways";
const TRAVEL_LIMIT = 400;
const CREDIT_LIMIT = 10000000;
const STABLING_CHARGES = 500;
// SFTO Fee Calculation
const CHARGEABLE_WEIGHT = 2830.0;
const BFNSM_CARRYING_CAPACITY = 69.6;
const BFNS_CARRYING_CAPACITY = 64.9;
const OVER_WEIGHT_PUNITIVE = 0;
const REBATE = 0.12;
const BUSY_SEASON_SURCHARGE = 0.15;
const DEV_SURCHARGE = 0.05;
const TACPERMT = 20;
const BASE_CHARGEABLE_WEIGHT = 2838.0;
const SLAB1_REBATE_PERCENTAGE = 0.02;
const SLAB2_REBATE_PERCENTAGE = 0.04;
const SLAB3_REBATE_PERCENTAGE = 0.06;
const SLAB4_REBATE_PERCENTAGE = 0.08;
const ADVANCE_REQUISTION_AMOUNT_PERCENTAGE = 1.65;
// SFTO Fee Calculations
const DEFAULT_LIST_VIEW_PAGINATION_OPTIONS = {
  RECORDS_PER_PAGE_OPTIONS: [5, 10, 20, 30],
  DEFAULT_RECORDS_PER_PAGE: 5,
  DEFAULT_INVOICE_RECORDS_PER_PAGE: 20,
  DEFAULT_RECORDS_PER_PAGE_DAILY_POSITION: 8,
  RECORDS_PER_CACHED_PAGE: 500,
  DEFAULT_ORDERBY: "customer_name",
  SORTBY_ASC: true,
};
const ALLOWED_EXTENSIONS = ["csv", "pdf", "xls", "xlsx", "doc", "docx"];
const ALLOWED_EXTENSIONS_SFTO_IR = ["pdf", "jpg", "jpeg"];
const ALLOWED_EXTENSIONS_GPWIS_IR = ["pdf", "jpg", "jpeg"];
const MAX_UPLOAD_SIZE = 50000;
const GPWIS_JOB_EXEC_STEPS = [];

const GPWIS_JOB_EXEC_STEPS_INFO = [
   {
    STEP_NAME: "Contract Details",
  },
  {
    STEP_NAME: "Job Approved / Rake Details",
    SUB_STEPS: ["Route Details", "Rake Arrival/Loading Details"],
  },
  {
    STEP_NAME: "RR Details",
    SUB_STEPS: ["RR Details", "Rake Departure Details"],
  },
  {
    STEP_NAME: "Unloading Details",
    SUB_STEPS: ["Unloading Details"],
  },
  {
    STEP_NAME: "Generate Invoice",
  },
  {
    STEP_NAME: "Invoice Details",
  }
];

// SFTO
const SFTO_JOB_EXEC_HORIZONTAL_STEPS = [
  "Transit Readiness",
  "Intransit",
  "Destination Details",
  "Return Details",
];
const SFTO_JOB_EXEC_STEPS_INFO = [
  {
    STEP_NAME: "Contract Details",
    // SUB_STEPS: ["Destination Details"],
  },
  {
    STEP_NAME: "Transit Readiness",
    SUB_STEPS: [
      "Indent Details",
      "Origin Details",
      "Loading Details",
      "Wagon Details",
      "RR Details",
      "Route Finalising",
    ],
  },
  // {
  //   STEP_NAME: "Intransit",
  //   SUB_STEPS: ["Intransit Details"],
  // },
  {
    STEP_NAME: "Destination Details",
    SUB_STEPS: ["Destination Details"],
  },
  {
    STEP_NAME: "Generate Invoice"
  },
  {
    STEP_NAME: "Invoice Details"
  },
  {
    STEP_NAME: "Return Details",
    SUB_STEPS: ["Return Details"],
  },
];
const RAKE_INDUCTION_STEPS_INFO = [
  "Quotation From Supplier",
  "PO to Supplier",
  "Rake Inspection Agency",
  "Rake Manufacturing",
  "Rake Delivery",
  "Rake Commissioning",
  "Spare Wagon Delivery",
  "Spare Wagon Commissioning"
];
export default {
  INIT_URL,
  LOB,
  DEFAULT_LIST_VIEW_PAGINATION_OPTIONS,
  TRAVEL_LIMIT,
  CREDIT_LIMIT,
  CHARGEABLE_WEIGHT,
  OVER_WEIGHT_PUNITIVE,
  BUSY_SEASON_SURCHARGE,
  REBATE,
  DEV_SURCHARGE,
  TACPERMT,
  BASE_CHARGEABLE_WEIGHT,
  SLAB1_REBATE_PERCENTAGE,
  SLAB2_REBATE_PERCENTAGE,
  SLAB3_REBATE_PERCENTAGE,
  SLAB4_REBATE_PERCENTAGE,
  ADVANCE_REQUISTION_AMOUNT_PERCENTAGE,
  ALLOWED_EXTENSIONS,
  MAX_UPLOAD_SIZE,
  GPWIS_JOB_EXEC_STEPS,
  GPWIS_JOB_EXEC_STEPS_INFO,
  SFTO_JOB_EXEC_HORIZONTAL_STEPS,
  SFTO_JOB_EXEC_STEPS_INFO,
  BFNSM_CARRYING_CAPACITY,
  BFNS_CARRYING_CAPACITY,
  STABLING_CHARGES,
  RAKE_INDUCTION_STEPS_INFO,
  ALLOWED_EXTENSIONS_SFTO_IR,
  ALLOWED_EXTENSIONS_GPWIS_IR
};
